import Message from "../../message";
import {useMainStore} from "@/store";

export default class SeasonActive extends Message
{
    handle()
    {
        useMainStore().SET_SEASON(this.message)
    }
}
